// ¡PRIMERO Y SIN TOCAR EL ORDEN! El cuerpo de un módulo ES corre después de que
// se hayan evaluado TODOS sus imports, así que un manejador escrito más abajo
// llega tarde: para entonces ya se evaluaron App, el logger y
// `services/supabase` con su `createClient()`. Si algo de eso revienta al
// cargarse no hay nadie escuchando, la app no arranca y el usuario ve una
// página en blanco de la que no nos enteramos.
//
// Este import es el primero para que su efecto —dos escuchas de error— quede
// puesto antes que nada. El módulo no importa nada, ni siquiera el logger.
// Ver utils/redDeArranque.ts. Mover esta línea deshace el arreglo.
import { conectarLogger } from './utils/redDeArranque';

import React from 'react';
import { IdiomaProvider } from './i18n/idioma';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ErrorBoundary } from './components/ErrorBoundary';
import { reportFailure } from './utils/logger';
import { installBreadcrumbs } from './utils/breadcrumbs';
import { installConsolePatch } from './utils/consolePatch';
import { installDomResilience } from './utils/domResilience';

// El grafo cargó: el logger existe. Se le pasa el testigo a la red de arranque,
// que le entrega lo que haya cazado mientras tanto y le manda lo que venga
// después. Desde aquí, `window.onerror` y `unhandledrejection` ya no se asignan
// en este archivo: los escucha redDeArranque y los reenvía a `reportFailure`.
conectarLogger(reportFailure);

// Order matters: breadcrumbs first (they intercept fetch), then console patch
// (which uses breadcrumbs and logger). Logger imports breadcrumbs lazily.
installBreadcrumbs();
installConsolePatch();
// DOM guard against browser page-translation corrupting React-owned nodes —
// must be live before the first React commit (i.e. before createRoot).
installDomResilience();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      {/* El idioma envuelve TODO, incluida la app: la barra de navegación y las
          pantallas de error tienen que poder traducirse igual que el resto. */}
      <IdiomaProvider>
        <App />
      </IdiomaProvider>
    </ErrorBoundary>
  </React.StrictMode>
);
